"use client";

import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface BulletPointProps {
  text: string;
  className?: string;
}

export function BulletPoint({ text, className }: BulletPointProps) {
  return (
    <div className={cn("flex items-start gap-4 mb-6 last:mb-0", className)}>
      <div className="shrink-0 mt-1">
        <div className="flex items-center justify-center size-6 rounded-full bg-ss-light-green">
          <Check className="size-4 text-white stroke-3" />
        </div>
      </div>
      <div className="grow leading-relaxed">
        {text}
      </div>
    </div>
  );
}

interface BulletPointListProps {
  items: string[];
  className?: string;
}

export function BulletPointList({ items, className }: BulletPointListProps) {
  return (
    <div className={cn("space-y-6", className)}>
      {items.map((text, index) => (
        <BulletPoint key={index} text={text} />
      ))}
    </div>
  );
}
